export default __webpack_public_path__ + "static/media/IMG-20210711-WA0004.c42d7e08.jpg";